import React from "react";
import { Icon } from '@genesis/ui-kit';
import { messages } from "../../Shared/Messages/ErrorMessages";
import classes from "./errorpage.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className={classes.mainDiv}>
      <div className={classes.error}><Icon name='errorOutlined' /> <b>{messages.WFM_SOMETHING_WENT_WRONG}</b></div>
      <div className={classes.subError}>{location.state!==null ? "("+location.state+")" : ''}</div>
      <div className={classes.backBtn}>
        <Button
          color="secondary"
          onClick={() => navigate("/")}
        >
          &nbsp; Back To Home
        </Button></div>
    </div>);
};

export default ErrorPage;
